"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextSize = void 0;
/**
 * Get a text size as if it was already rendered in DOM.
 *
 * @param text              text to measure
 * @param canvas            any specific canvas element to use for measuring
 * @param font         any custom style for a text, e.g. 'bold, 10px arial',
 * @param uppercase         whether to measure the text in uppercase or not
 * @param letterSpacingPx   any custom letter spacing
 */
const getTextSize = (text, canvas = document.createElement("canvas"), font = "", uppercase = false, letterSpacingPx = 0) => {
    if (!canvas) {
        return 0;
    }
    const context = canvas.getContext("2d");
    if (!context) {
        return 0;
    }
    const styledText = uppercase ? text.toUpperCase() : text;
    context.font = font;
    const metrics = context.measureText(styledText);
    const letterSpacingWidth = styledText.length * letterSpacingPx;
    return metrics.width + letterSpacingWidth;
};
exports.getTextSize = getTextSize;
